<template>
    <div class="relative">
        <i-table ref="tabela" :columns="pgd_colunas" :data="tickets_filtro" class="tickets-table" :loading="loading"/>
        <DrawerTicket v-model="edit_pgd" :id="edit_id"></DrawerTicket>
        <drawer title="Enviar email" :closable="true" width="850" v-model="enviar_email">
            <form-email v-if="enviar_email" :url="email.url" :assunto="email.assunto" :mensagem="email.mensagem" :disabled="false"
                        :onSend="emailEnviado"></form-email>
            <Card dis-hover :bordered="false">
                <div style="margin: 0 0 10px;"><b>Resumo</b></div>
                {{email.resumo}}
            </Card>
            <Card dis-hover :bordered="false">
                <div style="margin: 20px 0 10px;"><b>Descrição</b></div>
                <div v-html="email.descricao"></div>
            </Card>
            <Card dis-hover :bordered="false">
                <div style="margin: 20px 0 10px;"><b>Descrição da Solução</b></div>
                <div v-html="observacao"></div>
            </Card>
            <Card dis-hover :bordered="false">
                <div style="margin: 20px 0 10px;"><b>Solicitantes</b></div>
                <span v-for="(solicitante, key) in email.solicitantes" :key="key" class="multiselect__tag"><span>{{solicitante.nome_empresa}}</span></span>
            </Card>
        </drawer>
        <DrawerAndamento ref="drawer" :andamento="andamento" v-model="action"
            v-on:update="updateAction">
        </DrawerAndamento>
    </div>
</template>

<script>
    import {moment} from '../../../helpers/utils';
    import ticketMixin from '../../../mixins/ticket';

    export default {
        components: {
            FormEmail: () => import("./form-email.vue"),
            DrawerTicket: () => import("./Drawer.vue"),
            DrawerAndamento: () => import("./drawer-pgd-form-causas.vue")
        },
        name: 'tickets-table',
        mixins: [ticketMixin],
        props: {
            relatores: Array,
            analistas: Array,
            tickets: Array,
            ocultarTipo: Boolean,
            ocultarIdTickets: Boolean,
            ocultarRelatores: Boolean,
            ocultarAtribuido: Boolean,
            ocultarResumo: Boolean,
            ocultarObservacao: Boolean,
            ocultarCadastros: Boolean,
            ocultarFinalizados: Boolean,
            exibirSolicitantes: Boolean,
            exibirAndamento: Boolean,
            exibirDetalhes: Boolean,
            exibirOpcoes: Boolean,
            exibirProjeto: Boolean,
            exibirTempoDev: Boolean,
            exibirCriticidade: Boolean,
            exibirReaberto: Boolean,
            exibirIncidentes: Boolean,
            exibirModulo: Boolean,
            loading: Boolean,
            tempoPGD:Boolean,
            csv:Boolean,
        },
        data() {
            return {
                edit_pgd: false,
                edit_id: 0,
                enviar_email: false,
                items_showed: 0,
                observacao:'',
                email: {
                    url: "",
                    assunto: "",
                    mensagem: "",
                    emails: [],
                    descricao: ""
                },
                ocultar_tipo:this.ocultarTipo,
                pgd_colunas: [],
                action:false,
                andamento:{
                    id:null,
                    titulo:null,
                    descricao:null,
                    causa_titulo:null,
                    tipo_id:null,
                    sistema_id:null,
                    funcionalidade:null,
                },
            };
        },
        computed: {
            tickets_filtro() {
                return this.tickets.map(item => {
                    /**
                     * Trata o retorno dos dados dos tickets para serem exbidos corretamente na tabela
                     */
                    item.num_solicitantes = item.solicitantes.length;
                    item.tempo_aberto_sec =
                        item.status == 2
                            ? moment(item.data_hora_cadastro).diff(
                            moment(item.data_hora_fechamento),
                            "seconds"
                            )
                            : moment(item.data_hora_cadastro).diff(
                            moment(),
                            "seconds"
                            );
                    item.tempo_aberto =
                        item.status == 2
                            ? moment(item.data_hora_cadastro).from(
                            moment(item.data_hora_fechamento),
                            true
                            )
                            : moment(item.data_hora_cadastro).fromNow(true);
                    return item;
                });
            },
            permissoes() {
                return {
                    associar: () => {
                        /**
                         * Permissão: Administração
                         */
                        return [1, 29, 34].includes(this.cargo_user);
                    },
                    resolver: () => {
                        /**
                         * Permissão: Administração, Suporte e Testers
                         */
                        return [1, 4, 5, 6, 29, 34].includes(this.cargo_user);
                    },
                    fechar: () => {
                        /**
                         * Permissão: Administração e Testers
                         */
                        return [1, 4, 5, 6, 29, 34].includes(this.cargo_user);
                    }
                }
            },
            id_user() {
                return this.$store.getters.usuario.id_pessoa;
            },
            cargo_user() {
                return this.$store.getters.usuario.usuario_cargo;
            }
        },
        methods: {
            exportData(css) {
                const dataCsv = [];
                this.tickets_filtro.forEach(ticket => {
                    const newTicket = {};
                    this.pgd_colunas.forEach((coluna, index) => {
                        if (ticket[coluna.key]) {
                            newTicket[coluna.key] = ticket[coluna.key].toString().replace(/,/g, " ").replace(/\n+/, " ");
                        } else {
                            newTicket[`Coluna ${index}`] = " ";
                        }
                    });
                    dataCsv.push(newTicket);
                });
                this.$refs.tabela.exportCsv({
                    filename: 'Tickets',
                    data: dataCsv,
                    columns: this.pgd_colunas
                });
            },
            async opcaoTicket(id, opcao) {
                this.edit_id = _.findIndex(this.tickets, o => o.id_ticket === id)
                const ticket = this.tickets[this.edit_id]
                this.andamento.tipo_id = null
                this.andamento.funcionalidade = ticket.funcionalidade
                if (opcao === "Fechar") {
                    this.show_andamento = true
                    this.andamento.titulo = `Fechando Ticket ${id} (${ticket.resumo}...)`
                    this.andamento.descricao = `Observação`
                    this.andamento.id = 8
                    this.action = true
                } else if (opcao === "Resolver") {
                    this.show_andamento = true
                    this.andamento.titulo = `Resolvendo Ticket ${id} (${ticket.resumo}...)`
                    this.andamento.descricao = `Observação`
                    this.andamento.sistema_id = ticket.sistema_id
                    this.andamento.id = 7
                    this.action = true
                } else if (opcao === "Associar") {
                    const {id_associado} = await this.associarTicket(ticket);
                    const idx_ass = _.findIndex(this.tickets, o => o.id_ticket === id_associado)
                    if (idx_ass !== -1) {
                        this.tickets[idx_ass].associacoes_count += 1
                    }
                } else if (opcao === "Reabrir"){
                    await this.reabrirTicket(ticket)
                    this.$emit("ticketUpdate", {
                            ...this.tickets[this.edit_id],
                                status: 1,
                                andamento: 0
                    })
                } else if (opcao === "Desassociar"){
                    const id_associado = ticket.id_associado
                    await this.desassociarTicket(ticket)
                    const idx_ass = this.tickets.findIndex(o => o.id_ticket === id_associado)
                    if (idx_ass !== -1) {
                        this.tickets[idx_ass].associacoes_count - 1
                    }
                }
            },
            async updateAction(form=[]){
                const id = this.edit_id
                const ticket = this.tickets[id]
                let changes = {}
                try {
                    if (this.andamento.id === 8) {
                        await this.fecharTicket(ticket,form)
                        if (id) {
                            this.tickets.splice(id, 1)
                        } else {
                            this.tickets.shift()
                        }
                    } else if (this.andamento.id === 7) {
                        await this.resolverTicket(ticket,form)
                        if (id) {
                            this.tickets.splice(id, 1)
                        } else {
                            this.tickets.shift()
                        }
                    }
                } catch (ex) {
                    console.warn(ex)
                    this.$Message.error(`Erro! ${ex}`)
                }
                this.action = false
            },
            editTicket(id_ticket) {
                this.edit_id = id_ticket;
                this.edit_pgd = true;
            },
            enviarEmail(id_ticket) {
                const ticket = this.tickets.find(o => o.id_ticket == id_ticket);
                const email_enviado = ticket.email
                    ? JSON.parse(ticket.email)
                    : null;
                this.email.assunto = email_enviado ? email_enviado.assunto : "";
                this.email.url = `ticket/${id_ticket}/emailSolicitantes`;
                this.observacao = ticket.observacao;
                this.email.mensagem = email_enviado
                    ? email_enviado.mensagem
                    : ticket.observacao;
                this.email.resumo = ticket.resumo;
                this.email.descricao = ticket.descricao;
                this.email.solicitantes = ticket.solicitantes;
                this.enviar_email = true;
            },
            emailEnviado(result) {
                if (result){
                    this.enviar_email = false;
                    return true;
                }
                return false;
            },
            getIconPgd: (id, criticidade) => {
                const icons = {
                    32: "ios-bug",
                    33: "ios-star",
                    35: "ios-settings",
                    45: "ios-flash"
                };

                const colors = {
                    32: ["#F2ABAB", "#F2ABAB", "#E65757", "#D90000"],
                    33: ["#FFE8B6", "#FFE8B6", "#FFD06D", "#FFB822"],
                    35: ["#097BD0", "#097BD0", "#36A3F7", "#ABDAFC"],
                    45: ["#C8CDF4", "#C8CDF4", "#919BE9", "#5867DD"],
                };

                return {
                    type: icons.hasOwnProperty(id) ? icons[id] : "",
                    color: colors.hasOwnProperty(id) ? colors[id][criticidade] : "#36A3F7",
                }
            },
            carregarTipo(){
                this.pgd_colunas.push(
                    {
                        title: "Tipo",
                        maxWidth: 95,
                        key: "tipo_id",
                        render: (h, params) => {
                            const iconPgd = this.getIconPgd(params.row.tipo_id, params.row.criticidade || 0);
                            return h({
                                template: `<span class="content-column">
                                    <span style="position: relative; align-self: center;">
                                        <Icon type="${iconPgd.type}" color="${iconPgd.color}" style="font-size: 35px;"></Icon>
                                        <Icon v-if="${params.row.status == 2}" type="${params.row.andamento == 7 ? "md-checkmark" : "md-close"}"
                                            style="font-size: 39px; position: absolute; top: -2px; left: -2px;
                                            color: ${params.row.andamento == 7 ? "#00bfa5" : "#ff5252"}"></Icon>
                                    </span>
                                    ${params.row.sistema_nome}
                                </span>`
                            });
                        },
                        filters: [
                            {
                                label: "Bug",
                                value: 32
                            },
                            {
                                label: "Melhoria",
                                value: 33
                            },
                            {
                                label: "SS",
                                value: 35
                            },
                            {
                                label: "MVP",
                                value: 45
                            }
                        ],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            return row.tipo_id == value;
                        }
                    },
                )
            },
            carregarIdTickets(){
                this.pgd_colunas.push(
                    {
                        title: "",
                        key: "id_ticket",
                        maxWidth: 100,
                        sortable: true,
                        render: (h, params) => {
                            return h({
                                template: `<span class="content-column">
                                    <Tooltip placement="top" style="font-size:11px" content="ID Ticket">
                                        <Tag class="tag-ticket">${params.row.id_ticket}</Tag>
                                    </Tooltip>
                                    <Tooltip v-if="${params.row.movidesk_id}" placement="top" style="font-size:11px" content="ID Movidesk">
                                        <Tag class="tag-ticket">${params.row.movidesk_id}</Tag>
                                    </Tooltip>
                                </span>`
                            });
                        }
                    },
                )
            },
            carregarRelatores(){
                this.pgd_colunas.push(
                    {
                        title: "Relatado por",
                        key: "relatado_por_nome",
                        maxWidth: 160,
                        sortable: true,
                        filters: this.relatores,
                        filterMultiple: false,
                        render: (h, params) => {
                            return h(
                                "span",
                                params.row.relatado_por_nome
                                    ? params.row.relatado_por_nome.replace(
                                    / .*/,
                                    ""
                                    )
                                    : ""
                            );
                        },
                        filterMethod(value, row) {
                            return row.relatado_por_id == value;
                        }
                    },
                )
            },
            carregarAtribuido(){
                this.pgd_colunas.push(
                    {
                        title: "Atribuído a",
                        key: "atribuido_a_nome",
                        maxWidth: 150,
                        sortable: true,
                        filters: this.analistas,
                        filterMultiple: false,
                        render: (h, params) => {
                            return h(
                                "span",
                                params.row.atribuido_a_nome
                                    ? params.row.atribuido_a_nome.replace(/ .*/, "")
                                    : ""
                            );
                        },
                        filterMethod(value, row) {
                            return row.atribuido_a_id == value;
                        }
                    },
                )
            },
            carregarModulo(){
               this.pgd_colunas.splice(3, 0,
                    {
                        title: "Modulo",
                        key: "modulo",
                        sortable: true,
                        render: (h, params) => {
                            if(params.row.treemodulo && params.row.treefuncao && params.row.treefuncionalidade){
                                return h(
                                "span",
                                [
                                    h(
                                        "span",
                                        params.row.treemodulo.nome
                                    ),
                                    h("br"),
                                    h(
                                        "span",
                                        params.row.treefuncao.nome
                                    ),
                                    h("br"),
                                    h(
                                        "span",
                                        params.row.treefuncionalidade.nome
                                    ),
                                ]
                            );
                            }

                        },
                    },
                )
            },
            carregarResumo(){
                this.pgd_colunas.push(
                    {
                        title: "Resumo",
                        key: "resumo",
                        sortable: true,
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        fontSize: "16px"
                                    }
                                },
                                [
                                    h(
                                        "a",
                                        {
                                            attrs: {
                                                class: "table-edit"
                                            },
                                            on: {
                                                click: () =>
                                                    this.editTicket(
                                                        params.row.id_ticket
                                                    )
                                            }
                                        },
                                        [
                                            params.row.resumo,
                                            h("Icon", {
                                                props: {
                                                    type: "md-create"
                                                }
                                            })
                                        ]
                                    ),
                                    h("div",{
                                        style: {
                                            fontSize: "12px"
                                        }
                                    },params.row.projeto_nome),
                                ]
                            );
                        }
                    },
                )
            },
            carregarCriticidade(){
                this.pgd_colunas.splice(6,0,
                    {
                        title: "Criticidade",
                        width: 150,
                        key: "criticidade",
                        sortable: true,
                        render: (h, params) => {
                            let dateFechamento = moment(params.row.data_hora_fechamento)
                            if (params.row.tipo_id == 32) {
                                let dateRegister = moment(params.row.data_hora_reaberto || params.row.data_hora_cadastro)
                                let prazo = dateRegister.add(params.row.horas_desenvolvimento, 'hours')
                                return h("div", {
                                    class: "content-column"
                                },
                                [
                                    h("span", {
                                        class: {
                                            'font-bold': params.row.criticidade == 3,
                                            'text-red-dark': params.row.criticidade == 3,
                                        }
                                    },
                                        `${
                                        params.row.criticidade ==1 ? "BAIXA" :
                                            params.row.criticidade == 2 ? "MÉDIA" :
                                                params.row.criticidade ==3 ? "ALTA": ""}`),
                                    !(params.row.status == 2 && params.row.andamento != 7) ? h("Tooltip", {
                                        props: {
                                            placement: "top",
                                            content: `Prazo: ${prazo.format("DD/MM/YYYY H:mm")}`,
                                        }
                                    },
                                    [
                                       h("Countdown", {
                                            attrs: {
                                                class: 'font-bold',
                                            },
                                            props: {
                                                date: prazo,
                                                dateFechamento:dateFechamento,
                                                dateRegister:dateRegister,
                                                format: "digital"
                                            }
                                        })
                                    ]) : ''
                                ]);
                            } else {
                                let prazo = moment(params.row.data_hora_pgd).add(params.row.horas_desenvolvimento, 'hours');
                                let dateRegister = moment(params.row.data_hora_pgd)
                                return h("div", {
                                    class: "content-column"
                                },
                                [
                                    !(params.row.status == 2 && params.row.andamento != 7) ? h("Tooltip", {
                                        props: {
                                            placement: "top",
                                            content: `Prazo: ${prazo.format("DD/MM/YYYY H:mm")}`,
                                        }
                                    },
                                    [
                                        h("Countdown", {
                                            attrs: {
                                                class: 'font-bold',
                                            },
                                            props: {
                                                date: prazo,
                                                dateFechamento:dateFechamento,
                                                dateRegister:dateRegister,
                                                format: "digital"
                                            }
                                        })
                                    ]) : ''
                                ]);
                            }
                        },
                        filters: [
                            {
                                label: "Alta",
                                value: 3
                            },
                            {
                                label: "Média",
                                value: 2
                            },
                            {
                                label: "Baixa",
                                value: 1
                            }
                        ],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            return row.criticidade == value && row.tipo_id == 32;
                        }
                    },
                )
            },
            carregarObservacao(){
                this.pgd_colunas.push(
                    {
                        title: "Observação",
                        key: "observacao",
                        sortable: true,
                        render: (h, params) => {
                            const observacao = params.row.observacao != null?params.row.observacao:''
                            return h({
                                template: `<span>${observacao}</span>`
                            });
                        }
                    },
                )
            },
            carregarCadastros(){
                this.pgd_colunas.push(
                    {
                        title: "Cadastro",
                        key: "data_hora_cadastro",
                        maxWidth: 200,
                        sortable: true,
                        align: "right",
                        render: (h, params) => {
                            return h({
                                template: `<div class="data-cadastro">
                                    ${moment(params.row.data_hora_cadastro).format("DD/MM/YYYY")}
                                </div>`
                            });
                        }
                    },
                )
            },
            carregarFinalizados(){
                this.pgd_colunas.push(
                    {
                        title: "Finalizado",
                        key: "data_hora_fechamento",
                        maxWidth: 200,
                        sortable: true,
                        align: "right",
                        render: (h, params) => {
                            var datafinal
                            params.row.data_hora_fechamento == null?datafinal='Aberto há': datafinal=moment(params.row.data_hora_fechamento).format("DD/MM/YYYY")
                            return h({
                                template: `<div class="data-cadastro">
                                    ${datafinal}
                                    <Tooltip placement="top" style="font-size:11px" content="Tempo aberto">
                                        (${params.row.tempo_aberto})
                                    </Tooltip>
                                    </div>`
                            });
                        }
                    },
                )
            },
            carregarSolicitantes() {
                this.pgd_colunas.push(
                    {
                        title: "Solicitantes",
                        maxWidth: 115,
                        key: "num_solicitantes",
                        align: "center",
                        render: (h, params) => {
                            if (params.row.status == 2) {
                                return h(
                                    "a",
                                    {
                                        attrs: {
                                            id: params.row.id_ticket
                                        },
                                        on: {
                                            click: () =>
                                                params.row.num_solicitantes
                                                    ? this.enviarEmail(
                                                    params.row.id_ticket
                                                    )
                                                    : ""
                                        },
                                        style: {
                                            cursor: params.row.num_solicitantes
                                                ? "pointer"
                                                : "default",
                                            color: params.row.email
                                                ? "#00bcd4"
                                                : params.row.num_solicitantes
                                                    ? "unset"
                                                    : "#9e9e9e"
                                        }
                                    },
                                    [
                                        h(
                                            "Badge",
                                            {
                                                props: {
                                                    count:
                                                    params.row.num_solicitantes,
                                                    type: "info",
                                                    showZero: true
                                                }
                                            },
                                            [
                                                h("Icon", {
                                                    props: {
                                                        type: "md-mail",
                                                        id: params.row.id_ticket
                                                    },
                                                    style: {
                                                        fontSize: "20px"
                                                    }
                                                })
                                            ]
                                        )
                                    ]
                                );
                            }
                        }
                    });
            },
            carregarAndamento() {
                this.pgd_colunas.push(
                    {
                        title: "Andamento",
                        key: "andamento",
                        sortable: true,
                        maxWidth: 200,
                        render: (h, params) => {
                            return h("PgdAndamento", {
                                props: {
                                    id: params.row.id_ticket,
                                    andamento: params.row.andamento || 0
                                }
                            });
                        }
                    });
            },
            carregarOpcoes() {
                this.pgd_colunas.push(
                    {
                        title: " ",
                        width: 50,
                        render: (h, params) => {
                            const rel_id = params.row.relatado_por_id;
                            const dev_id = params.row.atribuido_a_id;
                            if (!(this.permissoes.resolver() || this.permissoes.fechar() || this.permissoes.associar() || rel_id == this.id_user || dev_id == this.id_user)) {
                                return;
                            }
                            return h("VxOptions", {
                                attrs: {
                                    id: params.row.id_ticket,
                                    onSelect: this.opcaoTicket,
                                    options: [
                                        {
                                            icone: "md-close",
                                            label: "Fechar",
                                            textColor: "#ff5252",
                                            show: true,
                                        },
                                        {
                                            icone: "md-checkmark-circle-outline",
                                            label: "Resolver",
                                            textColor: "#00bfa5",
                                            show: true,
                                        },
                                        {
                                            icone: "ios-git-merge",
                                            label: "Associar",
                                            textColor: "#00bcd4",
                                            show: true,
                                        },
                                        {
                                            icone: "ios-undo",
                                            label: "Reabrir",
                                            textColor: "#ff9900",
                                            show: true,
                                        },
                                        {
                                            icone: "ios-git-network",
                                            label: "Desassociar",
                                            textColor: "#17233d",
                                            show: true,
                                        }
                                    ].filter(item => {
                                        if (params.row.status === 2 && !params.row.id_associado) {
                                            // Ticket Fechado
                                            if (this.permissoes.fechar() || rel_id == this.id_user || dev_id == this.id_user) {
                                                return item.label === "Reabrir";
                                            }
                                        } else if (params.row.status === 2 && params.row.id_associado) {
                                            // Ticket Associado
                                            if (this.permissoes.associar()) {
                                                return item.label === "Desassociar";
                                            }
                                        } else if (item.label === "Resolver") {
                                            if (this.permissoes.resolver() || dev_id == this.id_user) {
                                                return item;
                                            }
                                        } else if (item.label === "Fechar" && params.row.tipo_id !== 45) {
                                            /**
                                             * MVP só podem ser resolvidos
                                             */
                                            if (this.permissoes.fechar() || rel_id == this.id_user || dev_id == this.id_user) {
                                                return item;
                                            }
                                        } else if (item.label === "Associar" && params.row.tipo_id !== 45 && !(params.row.andamento >= 1 || params.row.associacoes_count > 0)) {
                                            /**
                                             * Tickets em andamento não podem ser associados
                                             */
                                            if (this.permissoes.associar()) {
                                                return item;
                                            }
                                        }
                                    })
                                }
                            });
                        }
                    });
            },
            carregarProjeto() {
                this.pgd_colunas.push(
                    {
                        title: "Projeto",
                        key: "projeto_id",
                        maxWidth: 200,
                        sortable: true,
                        render: (h, params) => {
                            if (!params.row.projeto) {
                                return;
                            }
                            return h({
                                template: `<span>${params.row.projeto.nome}</span>`
                            });
                        }
                    });
            },
            carregarTempoPGD(){
                this.pgd_colunas.splice(5,1);
                this.pgd_colunas.push({
                    title: "Tempo Total",
                    key: "tempoTotal",
                    width: 250,
                    renderHeader: (h) => {
                        return h("div", [
                            h("Icon", {
                                props: {
                                    type: "md-alarm",
                                    size: "25"
                                }
                            }),
                            h('span', Math.round((this.tickets.reduce((acc,item) => acc+item.tempoTotal, 0) / this.tickets.length)) )
                        ])
                    },
                    render: (h,params)=>{
                        return h("span", `${params.row.tempoTotal} hs`);
                    }
                });
            },
            carregarDetalhes() {
                this.pgd_colunas.splice(7, 0,
                    {
                        title: " ",
                        width: 150,
                        render: (h, params) => {
                            return h(
                                "div",
                                {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-around"
                                    }
                                },
                                [
                                    h("PgdTimeline", {
                                        attrs: {
                                            id: params.row.id_ticket,
                                            total: params.row.timeline_count
                                        }
                                    }),
                                    h("Icon", {
                                        props: {
                                            type:
                                                params.row.tela_ux == 1
                                                    ? "ios-color-palette"
                                                    : "ios-color-palette-outline"
                                        },
                                        style: {
                                            fontSize: "22px",
                                            color: "#515a73",
                                            display: "block"
                                        }
                                    }),
                                    h("PgdAssociacoes", {
                                        attrs: {
                                            ac: parseInt(
                                                params.row.associacoes_count
                                            )
                                        }
                                    }),
                                    h("PgdGit", {
                                        props: {
                                            git: params.row.git
                                        }
                                    })
                                ]
                            );
                        }
                    });
            },
            carregarTempoDesenvolvimento(){
                this.pgd_colunas.push(
                    {
                        title: "Prazo",
                        key: "prazo",
                        sortable: true,
                        maxWidth:100,
                        align: 'center',
                        render: (h, params) => {
                            return h('span',
                                params.row.prazo?Math.round(params.row.prazo)+" hs":"0 hs"
                            )
                        }
                    },
                    {
                        title: "Desenvolvimento",
                        key: "tempo_dev",
                        sortable: true,
                        maxWidth:200,
                        align: 'center',
                        render: (h, params) => {
                            return h('span',
                                params.row.tempo_dev?Math.round(params.row.tempo_dev)+" hs":"0 hs"
                            )
                        }
                    },
                    {
                        title: "Checkout",
                        key: "checkout",
                        sortable: true,
                        maxWidth:150,
                        align: 'center',
                        render: (h, params) => {
                            const result = params.row.checkout
                            return h({
                                template: `
                                    <span>
                                        <Tooltip v-if="${result<0}"  placement="top" style="font-size:11px" content="Tempo excedido: ${result*-1} hs">
                                            <vs-icon icon="thumb_down" color="red"></vs-icon>
                                        </Tooltip>
                                        <Tooltip v-if="${result>0}"  placement="top" style="font-size:11px" content="Tempo ganho: ${result} hs">
                                            <vs-icon icon="thumb_up" color="green"></vs-icon>
                                        </Tooltip>
                                        <Tooltip v-if="${result==0}"  placement="top" style="font-size:11px" content="Tempo limite: ${result} hs">
                                            <vs-icon icon="thumb_up" color="green"></vs-icon>
                                        </Tooltip>
                                    </span>
                                `
                            });
                        }
                    }
                );
            },
            carregarReabertos(){
                this.pgd_colunas.push(
                    {
                        title: "Reaberto",
                        key: "qtd_reaberto",
                        maxWidth: 200,
                        sortable: true,
                        align: "right",
                        render: (h, params) => {
                            const qtd = params.row.qtd_reaberto == null ?'' : params.row.qtd_reaberto
                            return h({
                                template: `<span>
                                    ${qtd}
                                </span>`
                            });
                        }
                    },
                    {
                        title: "Reabertura",
                        key: "data_hora_reaberto",
                        maxWidth: 200,
                        sortable: true,
                        align: "right",
                        render: (h, params) => {
                            const data = params.row.data_hora_reaberto == null ?'' : moment(params.row.data_hora_reaberto).format("DD/MM/YYYY")
                            return h({
                                template: `<div class="data-cadastro">
                                    ${data}
                                </div>`
                            });
                        }
                    },
                )
            },
            carregarIncidentes(){
                 this.pgd_colunas.push(
                    {
                        title: "Incidentes",
                        key: "incidentes",
                        sortable: true,
                        align: 'center',
                        render: (h, params) => {
                            if (!params.row.timeline) return;
                            return h({
                                template: `<span>${params.row.timeline.reduce((accum, curr) => accum + curr.erros, 0)} erros</span>`
                            });
                        }
                    });
            },
            /**
             * Exibe a quantidade de itens que estão sendo filtrados
             */
            filteredItems() {
                this.$watch(
                    () => {
                        return this.$refs.tabela.$children[1].data
                    },
                    (val) => {
                        this.items_showed = val.length;
                    }
                );
            }
        },
        mounted() {
            if (this.ocultarTipo==false) {
                this.carregarTipo()
            }
            if (this.ocultarIdTickets==false) {
                this.carregarIdTickets()
            }
            if (this.ocultarRelatores==false) {
                this.carregarRelatores()
            }
            if (this.ocultarAtribuido==false) {
                this.carregarAtribuido()
            }
            if (this.ocultarResumo==false) {
                this.carregarResumo()
            }
            if (this.ocultarObservacao==false) {
                this.carregarObservacao()
            }
            if (this.ocultarCadastros==false) {
                this.carregarCadastros()
            }
            if (this.ocultarFinalizados==false) {
                this.carregarFinalizados()
            }
            if (this.exibirAndamento) {
                this.carregarAndamento()
            }
            if (this.exibirSolicitantes) {
                this.carregarSolicitantes()
            }
            if (this.exibirDetalhes) {
                this.carregarDetalhes()
            }
            if (this.exibirOpcoes) {
                this.carregarOpcoes()
            }
            if (this.exibirProjeto) {
                this.carregarProjeto()
            }
            if (this.exibirCriticidade){
                this.carregarCriticidade()
            }
            if (this.exibirTempoDev){
                this.carregarTempoDesenvolvimento()
            }
            if(this.exibirReaberto){
                this.carregarReabertos()
            }
            if (this.exibirIncidentes){
                this.carregarIncidentes();
            }
            if (this.exibirModulo){
                this.carregarModulo();
            }

            this.$nextTick(() => {
                this.filteredItems()
            });

            if(this.tempoPGD){
                this.carregarTempoPGD()
            }
        },
        watch:{
            csv(){
                if(this.csv){
                    this.exportData()
                }
            }
        }
    }
</script>

<style>
    .tickets-table .ivu-table-cell {
        overflow: inherit;
    }

    .data-cadastro .info {
        width: 113px;
        text-align: center;
        display: inline-block;
        color: #515a6e;
        font-size: 11px;
    }
</style>
